import React from 'react';
import { Info } from 'lucide-react';

/**
 * One-line quick instruction banner for organizer screens.
 * Place below the page header and above main content.
 */
const QuickInstruction = ({ text, className = '' }) => {
  if (!text) return null;
  return (
    <div
      className={`flex items-center gap-2 px-3 py-2 rounded-md bg-muted/60 border border-border/60 text-sm text-muted-foreground ${className}`}
      role="status"
      aria-label="Quick instruction"
    >
      <Info className="w-4 h-4 flex-shrink-0 text-muted-foreground" />
      <span>{text}</span>
    </div>
  );
};

export default QuickInstruction;
